import type { ReactNode } from 'react';

export const symbol_eraser_size_3: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M335-200q-56 0-95.5-39T200-334q0-26 10-50.5t30-44.5l291-292q20-20 44.5-29.5T626-760q56 0 95 39t39 95q0 26-9.5 50.5T721-531L429-239q-20 20-44 29.5t-50 9.5Z"
		/>
	</svg>
);
